import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, FormLabel, FormGroup, TextField, IconButton } from '@mui/material';
import { Refresh } from '@mui/icons-material';
import { getSearchParams } from '../../utils/url';
import { parseStringToInt } from '../../utils/parsing';
import { getBuildingIngestStatsAction } from '../../redux/actions/ingestStats';
import OrganizationsLoader from '../loaders/OrganizationsLoader';
import OrganizationSelector from '../userMgmt/OrganizationSelector';
import BuildingQa from './BuildingQa';
import BuildingsLoader from '../explore/BuildingsLoader';
import IngestStatsLoader from '../loaders/IngestStatsLoader';
import PointTypeLoader from '../loaders/PointTypeLoader';
import UnitsLoader from '../loaders/UnitsLoader';
import AlertsLoader from '../loaders/AlertsLoader';
import ActiveAlerts from './ActiveAlerts';

import './point-units.css';

/**
 * A component to drill down into buildings and points to inspect how well
 * data ingest is working
 */
class PointUnits extends Component {
  state = {
    org: null,
    orgSet: false,
    age: '48h',
  };

  getOrg() {
    const { org, orgSet } = this.state;
    const params = getSearchParams(this.props.location.search);
    // eslint-disable-next-line camelcase
    const urlOrgId = parseStringToInt(params?.org_id);
    return org != null || orgSet ? org : urlOrgId;
  }

  render() {
    const { age } = this.state;
    const org = this.getOrg();
    return (
      <div className="point-units">
        <OrganizationsLoader />
        <BuildingsLoader />
        <IngestStatsLoader key={age} interval={age} />
        <PointTypeLoader />
        <UnitsLoader />
        <AlertsLoader />

        <ActiveAlerts filter={({ key }) => key.indexOf('building-ingest') === 0} />

        <Grid container direction="row" justifyContent="space-around" alignItems="center">
          <Grid item xs={5}>
            <FormLabel>Organization</FormLabel>
            <FormGroup>
              <OrganizationSelector
                allowNulls
                selected={org}
                onValueChange={(orgId) => this.setState({ org: orgId, orgSet: true })}
              />
            </FormGroup>
          </Grid>
          <Grid item xs={1}>
            <FormLabel>Data interval</FormLabel>
            <FormGroup>
              <TextField value={age} onChange={(e) => this.setState({ age: e.target.value })} />
            </FormGroup>
          </Grid>
          <Grid item xs={1}>
            <IconButton onClick={() => this.props.reloadStats(age)} size="large">
              <Refresh />
            </IconButton>
          </Grid>
        </Grid>

        <BuildingQa org={org} />
      </div>
    );
  }
}

export default connect(null, (dispatch) => ({
  reloadStats: (age) => dispatch(getBuildingIngestStatsAction(age)),
}))(PointUnits);
